/**
 * Base Map Edit Page
 * 
 * Page for editing an existing base map.
 */

import React from 'react';
import { Container, SpaceBetween, Header } from '@cloudscape-design/components';
import BaseMapForm from '../../components/admin/BaseMapForm';

const BaseMapEdit: React.FC = () => {
  return (
    <SpaceBetween size="l">
      <Header
        variant="h1"
        description="Edit base map configuration"
      >
        Edit Base Map
      </Header>

      <Container>
        <BaseMapForm mode="edit" />
      </Container>
    </SpaceBetween>
  );
};

export default BaseMapEdit;
